import { FC } from 'react';
import { EditEmail } from './EditEmail/EditEmail';
import { store } from '@/config/store';

export const EditEmailPage: FC = () => {
  const { loginType } = store.state.loginInfo;
  return <EditEmail loginType={loginType} />;
};
